import { SelectOption } from '@cmg/design-system';
import { useIntl } from '@cmg/i18n';
import { useMemo } from 'react';

import { useCountriesAndCurrencies } from './useCountriesAndCurrencies';

export const US_COUNTRY_CODE = 'US';

export const useCountryOptions = () => {
  const intl = useIntl();
  const { countries, loading } = useCountriesAndCurrencies();

  const countryOptions = useMemo<SelectOption<string>[]>(
    () =>
      countries
        .map<SelectOption<string>>(({ id }) => ({
          label: intl.formatDisplayName(id, { type: 'region' }) ?? id,
          value: id,
        }))
        .sort((a, b) => {
          if (a.value === US_COUNTRY_CODE) {
            return -1;
          }
          if (b.value === US_COUNTRY_CODE) {
            return 1;
          }
          return a.label.localeCompare(b.label, intl.locale);
        }),
    [countries, intl]
  );

  return { countryOptions, loading };
};
